import i18n from "@/i18n";

export function titleGuard(to) {
  const t = i18n.global.t;

  const deepest = [...to.matched]
    .reverse()
    .find((r) => r.meta?.titleKey || r.meta?.title);

  const pageTitle =
    (deepest?.meta?.titleKey && t(deepest.meta.titleKey)) ||
    deepest?.meta?.title ||
    "Untitled";

  const suffix = t("site") || " | Site";
  document.title = `${pageTitle}${suffix}`;
}
